import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import classNames from "classnames";

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import joinModalStyle from "assets/jss/material-kit-react/components/joinModalStyle.jsx";

import CTASection from "components/CTASection/CTASection.jsx";

import joinTheMovementCtaModal from "data/join-the-movement-cta-modal.json";

import Surfers from "components/Background/Surfers.jsx";

class JoinModal extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      classes,
      buttonText,
      fullWidthButton,
      listIds,
    } = this.props;

    return (
      <div>
        <Button
          color="transparent"
          target=""
          className={classNames(classes.navLink)}
          style={{
            color: fullWidthButton ? "#A51CBE" : "#FF6601"
          }}
          onClick={this.handleClickOpen}
        >
          {buttonText}
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
        <Surfers style={{
          borderWith: "thick",
          borderStyle: "solid",
          borderColor: "black"
        }}>
          <CTASection     
          filterOpacity={0.5}
          cta={joinTheMovementCtaModal}
          fullWidth
          onSuccess={this.handleClose.bind(this)}
          onFailure={function(){}}
          onClose={this.handleClose.bind(this)}
          className={classes.modal}
          listIds={[31].concat(listIds)}
          >
          <Button
            color="transparent"
            className={classNames(classes.closeButton)}
            aria-label="Close"
            onClick={this.handleClose}
          >
            Close
          </Button>
          </CTASection>
        </Surfers>
        </Dialog>
      </div>
    );
  }
}

JoinModal.defaultProps = {
  buttonText: "Join"
};

export default withStyles(joinModalStyle)(JoinModal);